import React, {useMemo} from 'react';
import {Alert, Paragraph, Title} from '@zendeskgarden/react-notifications';
import {Span} from '@zendeskgarden/react-typography';

const ErrorEmployeeMessage = () => (
    <Alert type="error" style={{height: 119, width: 218}} data-testid="error-alert-display">
	  <Title>Oops!!</Title>
	  <Paragraph data-testid="error-message-display">
		  Oops !! It looks like the app is not loading. Please update the laptop repair/replacement details in SNow manually.
	  </Paragraph>
    </Alert>
);

export default ErrorEmployeeMessage;

